export default __webpack_public_path__ + "static/media/thumb-IVTS-3.dd1dc632.png";